import { notificationSuccess, notificationError, notificationHint, notificationInfo } from '@platform/icons';
import classnames from 'classnames';
import React from 'react';
import { Icon } from "../../icon/Icon.js";
import { Typography } from "../../typography/Typography.js";
import styles from "./Toast.module.js";
import "./Toast.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const getIconByType = type => {
  switch (type) {
    case 'info':
      return notificationInfo;
    case 'error':
      return notificationError;
    case 'success':
      return notificationSuccess;
    case 'warning':
      return notificationHint;
    default:
      throw new Error(`Unknown Icon Type ${type}`);
  }
};
/**
 * @deprecated Please use either the <Notification/> Component when placed inline, or use the generateToast function
 */
export const Toast = ({
  className,
  content,
  title,
  type = 'info'
}) => {
  const classes = classnames(styles.toast, className);
  return /*#__PURE__*/_jsxs("div", {
    className: classes,
    children: [/*#__PURE__*/_jsx(Icon, {
      icon: getIconByType(type),
      size: 30
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.content,
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h4",
        children: title
      }), content && /*#__PURE__*/_jsx("div", {
        children: content
      })]
    })]
  });
};